// extracted by mini-css-extract-plugin
module.exports = {"framework-selector":"J_dk d-flex","framework-selector__option":"J_dl p-2 flex-grow-1 ml-2","framework-selector__option--selected":"J_dm"};